'use client';

import { useEffect, useState } from 'react';
import { colors } from '@/constant/colors';

export interface ToastProps {
  id: string;
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  onClose: (id: string) => void;
}

export const Toast = ({ id, message, type = 'info', duration = 3000, onClose }: ToastProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    // 进入动画
    const enterTimer = setTimeout(() => {
      setIsVisible(true);
    }, 10);

    // 自动关闭
    const closeTimer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => {
      clearTimeout(enterTimer);
      clearTimeout(closeTimer);
    };
  }, [duration]);

  const handleClose = () => {
    setIsLeaving(true);
    setTimeout(() => {
      onClose(id);
    }, 300); // 等待退出动画完成
  };

  const getToastStyles = () => {
    const baseStyles = {
      transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
      opacity: isVisible ? 1 : 0,
    };

    // 使用黑色半透明背景，不再区分类型颜色
    const typeStyles = {
      success: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderColor: 'rgba(255, 255, 255, 0.2)',
      },
      error: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderColor: 'rgba(255, 255, 255, 0.2)',
      },
      warning: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderColor: 'rgba(255, 255, 255, 0.2)',
      },
      info: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderColor: 'rgba(255, 255, 255, 0.2)',
      },
    };

    return {
      ...baseStyles,
      ...typeStyles[type],
    };
  };

  return (
    <div
      className={`fixed left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 rounded-lg shadow-lg border transition-all duration-300 ease-in-out ${isLeaving ? 'opacity-0 translate-y-full' : ''
        }`}
      style={{
        ...getToastStyles(),
      }}
    >
      <span
        className="w-fit text-white text-sm font-medium text-center"
      >
        {message}
      </span>
    </div>
  );
};

export default Toast;
